import React, { useEffect } from 'react';
import { history } from 'store';
import { Creators as AuthCreators } from 'store/ducks/auth';
import { connect } from 'react-redux';
import { Spinner } from 'triider-components';
import {
  Container, BtnExit, UserImage, Subtitle, Loader,
  UserName, BtnManagerUser, Line, CompanyList, Logo, ContentListCompanies,
} from './styles';

function UserMenu({
  isOpen,
  logout,
  userName,
  emailUser,
  triiderUser,
  companies,
  loadingVisible,
  loadingCompany,
  userImage,
  minimized,
  userId,
  _getCompanies,
  _changeCompanyUser,
}) {
  useEffect(() => {
    _getCompanies({ userId: triiderUser.user.id });
  }, []);

  const handleChangeCompanyUser = (company) => {
    if (company.company_id !== triiderUser.company.id) {
      _changeCompanyUser({ company });
    }
  };

  return (
    isOpen && (
      <Container minimized={minimized}>
        <UserImage src={userImage} />
        <UserName>{userName}</UserName>
        <Subtitle>{emailUser}</Subtitle>
        <Line height={230} />
        <ContentListCompanies>
          <div>
            {loadingVisible || loadingCompany ? (
              <Loader>
                <Spinner size="larger" />
              </Loader>
            )
              : companies.map(company => (
                <CompanyList isDisabled={company.company_id === triiderUser.company.id} onClick={() => handleChangeCompanyUser(company)} key={company.company_id}>
                  <Logo src={company.square_logo_url} />
                  <div>
                    <b>
                      {company.name}
                    </b>
                    <br />
                    <span>
                      CNPJ:
                      {' '}
                      {company.cnpj}
                    </span>
                  </div>

                </CompanyList>
              ))}
          </div>
        </ContentListCompanies>

        <Line height={455} />
        <BtnManagerUser type="button" onClick={() => history.push(`/user/${userId}`)}>
          Gerenciar seu perfil
        </BtnManagerUser>
        <BtnExit type="button" onClick={() => logout()}>
          Sair
        </BtnExit>
      </Container>
    )
  );
}

const mapStateToProps = state => ({
  triiderUser: state.auth.triiderUser,
  companies: state.auth.companies,
  loadingVisible: state.ui.loaders.includes('GET_COMPANIES'),
  loadingCompany: state.ui.loaders.includes('CHANGE_COMPANY'),
});

const mapDispatchToProps = {
  _getCompanies: AuthCreators.getCompaniesByUserRequest,
  _changeCompanyUser: AuthCreators.changeCompanyUserRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
